import { AmplitudeExtendableEvent } from '@wetransfer/transfer/modules/analytics/vendors/amplitude';

export const DEVICE_NOT_RECOGNISED_EVENT: AmplitudeExtendableEvent = {
  action: 'Transfer Authentication',
  additionalProperties: {
    Step: 'device not recognised',
  },
};

export const NEW_DOWNLOAD_LINK_REQUESTED_EVENT: AmplitudeExtendableEvent = {
  action: 'Transfer Authentication',
  additionalProperties: {
    Step: 'new download link requested',
  },
};
